import { IdNumNomeDTO } from '@/interfaces/base-dto';
import IDoctor, { ICfm, MedicoParmDTO } from '@/interfaces/doctor';
import { apiClient } from '@/services/api';
import { ENDPOINTS } from '@/settings/api-settings';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

function getDoctors(filter: any = {}): Observable<IDoctor[]> {
  return from(
    apiClient.get(ENDPOINTS.DOCTORS, {
      ativo: filter.status,
    }),
  ).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export function getDoctorsCombo(status: boolean, idsUnidades: number[] = [], idsClientes: number[] = []): Observable<IdNumNomeDTO[]> {
  return from(
    apiClient.get(ENDPOINTS.DOCTORS_COMBO, {
      ativo: status,
      idsUnidades,
      idsClientes,
    }),
  ).pipe(map((r: any) => (!!r.data ? r.data : [])));
}


function getLeanDoctors(status: boolean = null, returnUnidades: boolean = false, idsUnidades: number[] = [], idsClientes: number[] = [], idsMedicos: number[] = []): Observable<IDoctor[]> {
  if (idsUnidades==null) {
    idsUnidades = [];
  }
  if (idsClientes==null) {
    idsClientes = [];
  }
  return from(
    apiClient.get(ENDPOINTS.DOCTORS, {
      ativo: status,
      returnUnidades,
      idsUnidades,
      idsClientes,
      idsMedicos
    }),
  ).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

function getDoctor(id: string, cfmValidate: boolean = false): Observable<IDoctor> {
  return from(
    apiClient.get(`${ENDPOINTS.DOCTORS}/${id}`, {
      validaCfm: cfmValidate,
    }),
  ).pipe(map((r: any) => r.data));
}

function saveDoctor(payload: MedicoParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.DOCTORS, payload)).pipe(
    map((r: any) => r.data),
  );
}
function updateDoctor(payload: MedicoParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.DOCTORS, payload)).pipe(
    map((r: any) => r.data),
  );
}

function getClientDoctors(id, filter: any = {}): Observable<any[]> {
  return from(
    apiClient.get(`/clientes/${id}/medicos`, {
      ativo: filter.status,
    }),
  ).pipe(map((r: any) => r.data || []));
}

function getCfmInformations(payload: any): Observable<ICfm> {
  return from(
    apiClient.get(ENDPOINTS.CFM_INFORMATIONS, {
      crm: payload.crm,
      uf: payload.crmUF,
    }),
  ).pipe(map((r: any) => r.data || {}));
}

export { getDoctors, getLeanDoctors, getDoctor, saveDoctor, updateDoctor, getClientDoctors, getCfmInformations, };

